import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TableService {

  api = environment.baseUrl + '/table';

  constructor(private apiConfig: HttpClient) { }

  /**
   * get table
   * @param tableNumber 
   */
  getTable(tableNumber: string): Observable<any> {
    return this.apiConfig.get(this.api + "/" + tableNumber);
  }
}
